export default {
  cancelOrderMap: {
    0: "istemiyorum.",
    1: "Ürünü yanlış yerleştirdim",
    2: "Tekrarlanan sipariş",
    3: "Alma başarısız oldu",
    4: "Diğer sebepler",
  },
  "当前余额": "Mevcut bakiye",
  "请选择": "Lütfen seçiniz",
  "获取验证码": "Doğrulama kodunu al",
  "请输入验证码": "Lütfen doğrulama kodunu girin",
  "验证码": "Doğrulama kodu",
  "发送": "Gönder",
  "已发送，请注意查收":
    "Gönderildi, lütfen yanıtınızı kontrol edin",
  "仅能绑定一个收款地址!": "Sadece bir ödeme adresi bağlayabilirsiniz!",
  "绑定成功": "Başarıyla bağlandı",
  "提款地址绑定": "Para çekme adresi bağlama",
  "电商批发商场": "E-ticaret toptan pazarı",
  "请输入完整的支付密码!" : "Lütfen tam ödeme şifresini girin!",
  "用户未发表评论": "kullanıcı yorum yapmadı",
  "订单": "Emir",
  "备注": "Not",
  "下单成功，等待付款": "Sipariş başarıyla verildi, ödeme bekleniyor",
  "下单成功，付款成功": "Sipariş başarıyla verildi, ödeme başarılı oldu",
  "已发货，正在运输中": "Sevk edildi, nakliyede",
  "订单已取消，原因:手动发起取消订单": "Sipariş iptal edildi. Sebep: Siparişi manuel olarak iptal edin.",
  "订单已取消，原因:超时自动取消订单": "Sipariş iptal edildi. Sebep: Sipariş, zaman aşımına uğradığında otomatik olarak iptal edilecektir.",
  "商家已确认，已进入备货状态": "Satıcı onaylandı ve stok durumuna girdi.",
  "系统发货成功": "Sistem teslimi başarılı oldu",
  "订单已签收": "Sipariş Alındı",
  "发起退款申请": "Bir geri ödeme isteği başlatın",
  "退款成功": "Geri ödeme başarılı oldu",
  "退款失败": "Geri ödeme başarısız oldu",
  "订单退款成功": "Siparişin geri ödenmesi başarılı oldu",
  "订单退款失败": "Sipariş geri ödemesi başarısız oldu",
  "系统默认好评": "Sistem varsayılan olarak olumlu incelemeleri kullanır",
  "请输入关键字搜索": "Lütfen aramak için anahtar kelime giriniz",
  "猜你喜欢": "Sanırım hoşuna gitti",
  "订单已完成": "Sipariş tamamlandı",
  "热销推荐": "Sıcak Satış Önerisi",
  "头像选择": "Avatar Seçimi",
  "修改头像": "Avatarını değiştir",
  subOrder: "Siparişi Gönder",

  "mailboxCheck": "Lütfen doğru e-posta adresini girin",
  "switchLang": "Lütfen görüntülemek için başka bir dile geçin",
  "myCart": "alışveriş sepetim",
  "notQua": "Kalifikasyon koşulları karşılanmamıştır.",
  "noSmaller": "Uygulanan miktar şundan az olamaz:",
  "nomax": "Maksimum başvuru miktarı geçemez",
  "evaluationUploading": "Hala yüklenen resimleriniz var. Lütfen daha sonra tekrar deneyiniz",
  "evaluateInput": "resimlerle incele",
  "moneyOrderStatus": "Sipariş durumu",
  "coinBlock": "Döviz sözleşmesi",
  "dealing": "işlemde",
  "dealSuccess": "Başarılı",
  "dealFail": "Hata",
  "payCertificate": "Ödeme sertifikası",
  "handleFee": "Servis bedeli",
  "highOpinion": "İyi eleştiriler",
  "mediumOpinion": "Orta inceleme",
  "lowOpinion": "Kötü yorumlar",
  "hasImage": "Resimleri olan",
  "rechargeMethod": "Şarj modu",
  "scanAndDown": "QR Kodunu Tara UYGULAMAYI İndir",
  "receivedAddress": "makbuz adresi",
  "ActualLedger": "Gerçek makbuz",
  "view": "Görüş",
  "withdrawNum": "Nakit çekme miktarı",
  "rechargeNum": "Şarj miktarı",
  "date": "Tarih",
  "walletHistory": "Cüzdan geçmişi",
  "accountBalance": "Hesap bakiyesi",
  "accountReview": "Hesap özeti",
  "rated": "İncelendi",
  "receiver": "Alıcı",
  "orderStatus": "Durum",
  "orderTime": "Zaman",
  "tax": "Vergilendirme",
  "discount": "İndirim",
  "productInfo": "Ürün Bilgisi",
  "paramError": "parametre hatası",
  "orderInfo": "Sipariş Bilgisi",
  "rebuy": "Bir sipariş daha",
  "pleaseCorrectAddress": "Lütfen doğru para çekme adresini girin",
  "pleaseInputCorrectNumber": "Lütfen 0'dan büyük bir sayı girin",
  "vcodePass": "Doğrulama geçti!",
  "vcodeFail": "Kimlik doğrulama başarısız oldu, lütfen tekrar deneyin",
  "uploading": "yükleniyor...",
  "uploadSuccess": "Yüklendi başarılı",
  "uploadError": "Yükleme başarısız. Lütfen tekrar deneyin",
  "registerSuccess": "Kayıt başarılı",
  "pleaseSetMobileNumber": "Lütfen telefon numarasını ayarlayın",
  "unSelectedProduct": "Bir ürün seçmediniz",
  "loginSuccess": "Giriş başarılı",
  "pleaseSetAreaCode": "Aranacak ülke adını ve alan kodunu girin",
  "login": "Giriş yapmak",
  "register": "Kayıt",
  "logout": "çıkış",
  "noData": "Veri bulunamadı",
  "search": "Aramak",
  "historySearch": "Tarihsel arama",
  "empty": "Boş",
  "home": "Anasayfa",
  "favorableRate": "İyi yorumların oranı",
  "classification": "Kategori",
  "searchTips": "Kaynak arama/ürün/tedarikçi/sipariş",
  "dailyNewArrival": "Listelenen günlük yeni ürünler",
  "more": "Daha",
  "recommend": "Öneri",
  "recommendedProducts": "Önerilen ürünler",
  "recommendedStore": "Önerilen mağazalar",
  "buyNow": "Şimdi satın al",
  "addCart": "alışveriş sepetine ekle",
  "complex": "Birleşik",
  "price": "Fiyat",
  "retailPrice": "Perakende fiyatı",
  "originPrice": "Orijinal fiyat",
  "service": "Müşteri servisi",
  "collect": "Favoriler",
  "sold": "Satış hacmi",
  "pageviews": "tarama miktarı",
  "quantity": "Miktar",
  "freight": "Kargo",
  "shipping": "Nakliye",
  "ship": "Bot",
  "buyTips": "Siparişi verdikten sonra 24 saat içinde kargoya verilir. Aşağıdaki siparişler lojistik kontrol altındadır ve geç sevk edilebilir. Lütfen lojistik bilgilerine dikkat edin veya müşteri hizmetleri ile iletişime geçin.",
  "totalPrice": "Toplam fiyat",
  "addCartMessage": "Alışveriş sepetine başarıyla eklendi",
  "addCartMessageFaild": "Ürün zaten alışveriş sepetinde var.",
  "myAccount": "q hesabım",
  "buyHistory": "Satın alma kayıtları",
  "wishlist": "favori ürünler",
  "trackOrder": "Emir",
  "account": "Hesap:",
  "sellerZone": "Tüccar alanı",
  "beSeller": "Tüccar ol",
  "sellerPanelLogin": "Satıcı girişi",
  "footTip": "© Telif Hakkı {name} Ltd 2024",
  "footTips": "{name} Limited, Finansal Yürütme Otoritesi tarafından bir kredi komisyoncusu (713206) olarak yetkilendirilir ve düzenlenir ve yalnızca {name} Finansal Hizmetler olarak borç veren Home Retail Group CardServices Limited ile ilgilenir. {name} Finansal Hizmetleri, kredi sağlamak için Mali Davranış Otoritesi tarafından yetkilendirilmiş ve düzenlenmiştir (716148). Ev Perakende GrubuCard Services Limited, Birleşik Krallık'ta (04007072) Avebury, 489-499 Avebury Boulevard, Milton Keynes, Birleşik Krallık adresinde kayıtlıdır. MK9 2NW.",
  "item": "Madde",
  "checkout": "Sipariş vermek",
  "productDescription": "Ürün Açıklaması",
  "userEvaluation": "kullanıcı yorumları",
  "AllProducts": "Tüm ürünler",
  "followers": "Takip etmek",
  "sales": "Satış hacmi",
  "visitStore": "mağazayı ziyaret et",
  "authentic": "%100 Hakiki",
  "dayReturns7": "7 gün dönüş",
  "shippingDiscounts": "navlun indirimi",
  "safePayment": "Güvenli ödeme",
  "followed": "Takip etti",
  "dashboard": "Enstrüman paneli",
  "myOrder": "Benim siparişim",
  "setUp": "Kurmak",
  "successTips": "Başarılı",
  "copySuccess": "Çoğaltma başarılı",
  "balance": "Bakiye(USDT)",
  "sort": "Tip",
  "commodity": "Ürün",
  "browse": "Satış hacmi",
  "recharge": "şarj et",
  "commodityCollection": "Ürün koleksiyonu",
  "withdraw": "nakit çekme",
  "defaultAddress": "Varsayılan adres",
  "addNewAddress": "yeni adres ekleyin",
  "withdrawRecord": "Nakit çekme kaydı",
  "serialNumber": "sipariş numarası",
  "time": "Zaman",
  "amount": "Miktar",
  "processing": "işlemde",
  "fail": "Hata",
  "blockchainNetwork": "Blockchain ağı",
  "records": "Kayıt",
  "withdrawAddress": "Para çekme adresi",
  "withdrawInputTips": "Lütfen para çekme adresini girin",
  "copy": "çoğaltma",
  "enterTips": "Girin lütfen",
  "actualAccount": "gerçek hesap",
  "handlingFee": "Servis bedeli",
  "confirm": "Makbuzu onaylayın",
  "previous": "Önceki adım",
  "pleaseEnterAddress": "lütfen adresi giriniz",
  "pleaseEnterQuantity": "Lütfen miktar giriniz",
  "withdrawSuccess": "Siparişler başarıyla gönderildi",
  "saveQr": "QR kodunu kaydet",
  "pleaseEnterAmount": "Lütfen yeniden yükleme miktarını girin",
  "expectedArrival": "Beklenen varış",
  "currentRate": "cari döviz kuru",
  "uploadTips": "Ödeme belgesi (Ödeme ayrıntılarının ekran görüntüsünü yükleyin)",
  "clickUpload": "yüklemek için tıklayın",
  "uploadPhoto": "Lütfen fotoğraf yükleyin",
  "rechargeSuccessful": "Şarj başarılı",
  "rechargeTips": "\"Yeniden yükleme istemi: \"\"Lütfen gerçek aktarım miktarını doğru bir şekilde girin. Aksi takdirde, sistem onayı geçemeyebilir ve yeniden yükleme sürecini etkileyebilir.\"",
  "rechargeRecord": "Şarj kaydı",
  "all": "Tüm",
  "pending": "Ödenecek",
  "cancelled": "İptal edildi",
  "delivered": "Sevk edilecek",
  "confirmed": "Onaylanmış",
  "receipt": "alınacak",
  "harvested": "Kabul edilmiş",
  "comment": "gözden geçirilecek",
  "refund": "Geri ödeme/satış sonrası",
  "cancelOrder": "Siparişi iptal et",
  "cancelReason": "İptal sebebi",
  "cancelOrderTitle": "Lütfen bir sipariş iptal nedeni seçin",
  "returnOrderTitle": "Lütfen iade nedenini seçin",
  "refundInstructions": "Geri ödeme talimatları",
  "returnDetailTips": "Lütfen ürün hakkında yorum yapın",
  "cancel": "Siparişi iptal et",
  "cancelOrder1": "Ürün alınmadı",
  "cancelOrder2": "Sevmiyorum, istemiyorum",
  "cancelOrder3": "Satıcı yanlış malları gönderdi",
  "cancelOrder4": "sahte marka",
  "cancelOrder5": "Daha az gönderi, kaçırılan gönderi",
  "cancelOrder6": "Alınan ürün hasarlı",
  "cancelOrder7": "kalite sorunu var",
  "cancelOrder8": "Satıcıyla geri ödeme için pazarlık yapın",
  "cancelOrder9": "Diğer sebepler",
  "cancelOrderSuccess": "Sipariş başarıyla iptal edildi",
  "returnOrderSuccess": "Başarıyla gönder",
  "orderName": "İsim",
  "orderEmail": "E-posta",
  "orderAddress": "Adres",
  "orderNation": "Ülke",
  "orderState": "Durum",
  "orderCity": "Şehir",
  "orderPostCode": "Posta Kodu",
  "orderAmount": "Miktar",
  "orderPrefix": "Genel sipariş toplamı",
  "orderFee": "vergiler",
  "orderSpecification": "Şartname",
  "orderCommodity": "Ürün",
  "orderQuantity": "Miktar",
  "orderUnitprice": "Birim fiyat",
  "orderFreight": "Kargo",
  "orderTax": "Vergi",
  "orderTotal": "Toplam",
  "PaymentOrder": "Ödeme talimatı",
  "Evaluate": "Gözden geçirmek",
  "CancelOrder": "Siparişi iptal et",
  "RemindShip": "Sevkiyat için Hatırlat",
  "Refund": "Geri ödemek",
  "Submitareview": "İnceleme gönder",
  "Information": "Bilgi",
  "wrongPassword": "3 defadan fazla şifre hatası. Lütfen yarın tekrar deneyin.",
  "Operate": "Operasyon",
  "Item": "Öğeler)",
  "From": "İtibaren",
  "hint": "İpuçları",
  "CheckDetails": "Detayları göster",
  "Payment": "Ödeme",
  "Cancel": "İptal etmek",
  "refundSuccessfully": "Geri ödeme başarılı oldu",
  "pendingPayment": "Ödenecek",
  "pay": "Ödeme",
  "LoginPassword": "Giriş şifresi",
  "sure": "Elbette",
  "shippingAddress": "alıcı adresi",
  "pleaseAddShippingAddress": "Lütfen önce bir teslimat adresi ekleyin",
  "transactionPassword": "İşlem Şifresi",
  "markDefaultAddress": "Varsayılan Gönderim adresi olarak işaretle",
  "edit": "Tarafından düzenlendi",
  "delete": "Silmek",
  "Opt": "Seçme",
  "piece": "Adet",
  "orderDetails": "Sipariş detayları",
  "shopCollection": "Mağazayı favorilere ekle",
  "addAddress": "yeni adres ekleyin",
  "signUp": "Kayıt",
  "loginTips": "Zaten hesabınız var mı?",
  "loginIn": "Giriş yapmak",
  "mobile": "Telefon yok",
  '购物车还没有商品': "Alışveriş sepetinde henüz ürün yok",
  '去购物': "Alışverişe başla",
  "modifyAddress": "Adresi değiştir",
  "desc": "Varsayılan adres olarak ayarla",
  "keep": "Sürdürmek",
  "onlineService": "Çevrimiçi hizmetler",
  "send": "Göndermek",
  "EsShop": "Online mağaza",
  "desc3": "işlem şifresini girin",
  "desc4": "işlem şifrenizi girin",
  "desc6": "İşlem şifrenizi tekrar girin",
  "setUpPayPaw": "İşlem şifresini ayarla",
  "setSuccess": "Kurulum başarılı",
  "confirmPayPaw": "İşlem şifresini onaylayın",
  "paymentSuccessful": "ödeme başarılı",
  "paymentPending": "Ödeme Beklemede",
  "paymentPendingDesc": "Ödemeniz işleniyor, lütfen daha sonra sipariş durumunuzu kontrol edin",
  "desc5": "Yanlış teslimat adresi? Temas etmek",
  "customeService": "çevrimiçi müşteri hizmetleri",
  "BackHome": "Ana sayfaya geri dön",
  "Checkorder": "Siparişi görüntüle",
  "ForgotPassword": "Parolayı mı unuttunuz?",
  "signIn": "Giriş yapmak",
  "noAccount": "Hesap numarası yok mu?",
  "pleaseEnterAccount": "Lütfen hesap numarasını girin",
  "pleaseEnterPassword": "Lütfen şifre giriniz",
  "password": "Şifre",
  "mobilePhone": "Telefon numarası",
  "pleaseEnterPhoneNumer": "Lütfen telefon numarasını ayarlayın",
  "setPassword": "Şifreyi belirle",
  "noDataFound": "Veri bulunamadı",
  "searchCountry": "Aranacak ülke adını ve alan kodunu girin",
  "pleaseEnterEmail": "Lütfen posta kutusunu ayarlayın",
  "invitationCode": "Davet Kodu",
  "plaeseEnterInvitaionCode": "Lütfen davet kodunu ayarlayın",
  "pleaseSetLoginPassword": "Lütfen giriş şifresini ayarlayın",
  "selectDeliveryAddress": "Gönderim adresini seçin",
  "totalOf": "Toplam",
  "items": "Öğe",
  "orderSummary": "Sipariş özeti",
  "paymentMethod": "Ödeme yöntemi",
  "Balance": "Denge",
  "payPal": "paypal",
  "notOpen": "Bu ödeme yöntemi bölgeniz için henüz açık değil",
  "mastercard": "MasterCard",
  "additional": "Ekstra",
  "handlingfee": "Servis ücreti gerekli",
  "goodsNumber": "ürün miktarı",
  "deliveryFee": "navlun",
  "totalNum": "Toplam",
  "new": "Yeni",
  "oldPassword": "Eski Şifre",
  "pleaseEnterOldPassword": "Lütfen eski şifreyi girin",
  "newPassword": "Yeni Şifre",
  "plaseeEnterNewPassword": "Lütfen yeni şifreyi girin",
  "confirmPassword": "Şifreyi Onayla",
  "plaseeENterConfirmPassword": "Lütfen onay şifresini girin",
  "twoPawword": "İki şifre aynı değil",
  "rechargeAddress": "Şarj adresi",
  "plaseEnterRechargeAddress": "Lütfen şarj adresini girin",
  "userCenter": "Kişisel merkez",
  "merchantSettled": "Tüccar girişi",
  "upNew": "Listelenen yeni ürün",
  "balanceNot": "Denge yeterli değil. Lütfen şarj edin.",
  "NoProductSelected": "Ürün henüz seçilmedi",
  "ShippingAddressNotSet": "Gönderim adresi belirlenmedi",
  "consigneeName": "Alıcının adı",
  "email": "E-posta:",
  "areaCode": "Uluslararası alan kodu",
  "phoneNumber": "Telefon numarası",
  "nation": "Ülke",
  "state": "İl/Eyalet/Eyalet",
  "city": "Şehir",
  "postCode": "Posta Kodu",
  "address": "Detaylı adres",
  "addAddressOrModifyAddress": "Yeni adres ekle/Adresi değiştir",
  "setAsTheDefaultAddress": "Varsayılan adres olarak ayarla",
  "proceed": "Devam etmek",
  "btnSure": "Onaylamak",
  "pleaseInput": "Girin lütfen",
  "allProduct": "Tüm ürünler",
  "myCommodityCollection": "favori ürünler",
  "myFollowedShops": "mağazayı takip et",
  "mySold": "Satılmış",
  "myPageviews": "tarama miktarı",
  "myPraiseRate": "İyi yorumların oranı",
  "myUnfollow": "takibi bırak",
  "inputNum": "Sayılar",
  "inpuEmailErro": "Lütfen doğru e-posta adresini girin",
  "goodsShip": "gönderi",
  "goodsShipTips": "Ürünler sipariş verildikten sonra 24 saat içerisinde kargoya verilir. Bir sonraki sipariş için lojistik kontrol varsa, sipariş gecikebilir. Lütfen siparişin lojistik bilgilerine dikkat edin veya müşteri hizmetleri ile iletişime geçin.",
  "goodsFreight": "navlun",
  "goodsFreeShipping": "Ücretsiz",
  "goodsFreightTips1": "1. Sınır ötesi ürün navlun kompozisyonu: navlun=sevk ücreti+ uzun mesafe navlun+ teslimat ücreti",
  "goodsFreightTips2": "2. Posta koşullarının sağlanmaması durumunda, navlun fiili koşullara göre ücretlendirilir.",
  "goodsFreightTips3": "3. Nihai yorumlama hakkı platforma aittir.",
  "pleaseValidPostCode": "Lütfen 4 haneden fazla girin",
  "pleaseValidEmail": "Lütfen doğru e-posta adresini girin",
  "pleaseValidPhone": "Lütfen doğru telefon numarasını girin",
  "productAvailable": "Bu ürün kaldırıldı",
  "validatorMaxNumber": "Tutar sınırı aşıyor",
  "validatorRequire": "Gerekli öğeler null olamaz",
  "validatorPhone": "Lütfen doğru telefon numarasını girin",
  "validatorEmail": "Lütfen doğru e-posta biçimini girin",
  "validatorPassword": "Şifre 6-12 hane veya harflerden oluşur(özel karakterler içerir)",
  "validatorSixNumber": "Lütfen 6 tam basamak girin",
  "validatorFourMoreNumber": "Lütfen 4-32 rakam veya harf kombinasyonu girin",
  "validatorIpRule": "Yanlış IP formatı",
  "validatorChineseAndEnglish": "Yalnızca Çince ve İngilizce, aralık girin: 8-64 karakter",
  "collectionSuccess": "Başarıyla favorilere ekle",
  "followedSuccess": "takip başarılı",
  "cancelSuccess": "İptal edildi başarılı",
  "加值": "Değer ekle",
  "提领": "Çekme",
  "平台人工发起退款": "Platform manuel olarak iade başlatır",
  "银行卡": "Banka kartı",
  "联系商家": "Tüccarla iletişime geçin",
  "evaluateOrder": "resimlerle incele",
  "evaluateOrderPlaceholder": "Lütfen ürünleri inceleyin",
  "operationSuccess": "İşlem başarılı oldu",
  "confirmReceiveGoods": "Ürünün alındığını onaylayın veya onaylayın",
  "evaluateOrderSuccess": "İnceleme başarılı oldu",
  "yesterday": "Dün",
  "notLogin": "Henüz giriş yapmadınız.",
  "delAllHistoryRecord": "Tüm geçmiş kaydını silmek istediğinizden emin misiniz?",
  "or": "Veya",
  "tipsRemindsText": "Gönderi hatırlatıldıktan sonra tüccar bir hatırlatma alacak",
  "tipsRemindsCount": "Sadece bir kez hatırlatılabilir.",
  "tipsRemindsMerchant": "Satıcılara hatırlat",
  "tipsRemindsSuccess": "Hatırlatma başarılı oldu",
  "noCartTips": "Alışveriş çantanız boş. Alışverişe başla.",
  "defaultRate": "Sistem varsayılan olarak olumlu incelemeleri kullanır",
  "prevPage": "Önceki sayfa",
  "nextPage": "Sonraki Sayfa",
  "returnApply": "İade talebi",
  "returnReason": "Geri ödeme nedeni",
  "returnAmount": "İade tutarı",
  "returnRemark": "İade talimatları",
  order: {
    "Cancel": "İptal etmek",
    "payment": "Şimdi öde",
    "remind": "Sevkiyat için Hatırlat",
    "return": "Ürün iadesi talebi",
    "evaluate": "Şimdi inceleyin",
    "logistics": "Lojistiği görüntüle",
    "noRefund": "geri ödemesiz",
    "refunding": "Geri ödeme devam ediyor",
    "refundSuccess": "Geri ödeme başarılı oldu",
    "refundFail": "Geri ödeme başarısız oldu",
  },
  "remindTitle": "Sevkiyat için Hatırlat",
  "remindContent": "Sevkiyat hatırlatıldıktan sonra, satıcı hatırlatıcıyı alır. Sadece bir kez hatırlatılabilir.",
  "remindSuccess": "Hatırlatma başarılı oldu",
  "remindRepeat": "Bu emir hatırlatıldı.",
  "noComments": "Şu anda inceleme yok",
  "storeSeach": "Bu mağazada ürün arayın",
  "storeSeachTips1": "senin için bulundu",
  "storeSeachTips2": "İlgili mağazalar bulundu",
  "storeSeachTips3": "Ev",
  "creditTit": "Kredi hizmetleri",
  "getCoupons": "Daha fazla kupon alın",
  "yourEmail": "e-posta adresiniz",
  "subscription": "Abonelikler",
  "paymethods": "Ödeme yöntemi",
  "footdec": "{name} global site kullanıcıları dünyanın {num} ülkesinden gelmektedir ve takas için {coin} kullanmaktadır. {coin}, dünya çapında bekleme ve uluslararası ücretler olmadan anında, düşük maliyetli işlemlere olanak tanıyan sınırsız bir işlemdir.",
  "custService": "Müşteri servisi",
  "helpLine": "çevrimiçi müşteri hizmetleri",
  "contactUs": "Bize Ulaşın",
  "partner": "kooperatif tedarikçileri",
  "buyRules": "alıcı kuralları",
  "客户端下载": "İstemci indir",
  "提现方式": "Para çekme yöntemi",
  "sellerRules": "satıcı politikası",
  "returnsAndEx": "İade ve Değişim",
  "servicePolicy": "hizmet politikası",
  "returnPolicy": "İade politikasi",
  "user_Center": "kullanıcı merkezi",
  "userReg": "kullanıcı kaydı",
  "orderTrack": "sipariş sorgusu",
  "purchageHistory": "Satın alım geçmişi",
  "myPurse": "Cüzdanım",
  "aboutUs": "Hakkımızda",
  "Recruitment": "Yetenekli kişileri bekleyin",
  "news": "haber bilgileri",
  "stateMent": "Modern kölelik beyanı",
  "binance": "Binance",
  "huobi": "huobi",
  "okx": "okx",
  "metaMask": "Meta Maske",
  "homeBannertips1": "Tüccar ol",
  "homeBannertips2": "Toplam komisyon",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Şimdi Katıl",
  "homeDownloadtips1": "Sınır ötesi e-ticaret toptan alışveriş merkezi",
  "homeDownloadtips2": "Markaya özel teklif",
  "homeDownloadtips3": "Kesintisiz indirim",
  "homeDownloadtips4": "android indir",
  "homeDownloadtips5": "elma indir",
  "homeDownloadtips6": "APP'yi indirmek için QR kodunu tarayın",
  "homeIconTips1": "%100 Hakiki",
  "homeIconTips2": "7 gün dönüş",
  "homeIconTips3": "navlun indirimi",
  "homeIconTips4": "güvenli ödeme",
  "headerSearchTips": "Lütfen aramak için anahtar kelime giriniz",
  "collAccount": "kredi modu",
  "mine": "Bana ait.",
  "creditText1": "Başlangıç kredileri, borç para alma derdini çözüyor",
  "creditText2": "Başlangıç kredisi ve sermaye devir hizmetleri sağlamak",
  "creditWorry": "sorunsuz kredi",
  "creditQuota": "Esnek limit",
  "creditQuotaINFO": "100.000 ila 30.000.000, esnek limitli ve kısıtlamasız, maksimum kredi vadesi bir yıl.",
  "quickLoan": "hızlı kredi",
  "creditReview": "Denetimden en erken bir saat içinde geçin, incelemeden geçilirse kredi hemen serbest bırakılır.",
  "safe": "Güvenli ve endişesiz",
  "safeInfo": "İpotek yok, depozito yok, geri arama yok çünkü bu aslında özel bir mesele.",
  "about": "Hakkımızda",
  "aboutText1": "Önce müşteri iş felsefesine dayalı olarak finansal hizmetleri ödünç vermeye kararlıyız, müşteri sermaye devri sorununu çözme misyonunu üstleniyoruz. Kuruluşundan bu yana şirket, çok sayıda müşterinin sermaye devri sorununu çözmesine yardımcı olmuştur.",
  "aboutText2": "Limit: 100.000-30.000.000, düşük faizli esnek geri ödeme yöntemi, ön ödemesiz, çevrimiçi kredi, doğrulama için telefon aranması yok, gizli bilgiler ve aynı gün borç verme.",
  "contactUs1": "Seviye arkadaşlarınızdan borç para almak istemiyorsanız, lütfen bizimle iletişime geçin.",
  "committed": "Girişimci kredi hizmetlerine bağlı",
  "financial": "Mali endişelerinizi ele alın",
  "partnersTit": "İş Ortağı Çevrimiçi Ödünç Verme Platformu",
  "application": "Kredi başvurusu",
  "applicant": "Başvuru sahibi",
  "actualName": "Gerçek ad",
  "yourName": "Lütfen adı girin",
  "term": "kredi süresi",
  "applicationAmount": "Talep edilen miktar",
  "rates": "kredi faiz oranı",
  "loanMethod": "kredi modu",
  "accountB": "Hesap bakiyesi",
  "countryOf": "Milliyet",
  "myloan": "kredim",
  "applyLoan": "kredi başvurusu",
  "loaned": "ödünç",
  "interest": "Tahakkuk eden faiz",
  "esRepayment": "tahmini geri ödeme",
  "loanHistory": "kredi kaydı",
  "applicantDate": "Başvuru tarihi",
  "repayment": "geri ödeme",
  "cycle": "geri ödeme döngüsü",
  "fixedRate": "sabit faiz oranı",
  "successLoan": "Kredi başarılı oldu",
  "Reapply": "yeniden başvur",
  "borrow": "Kredi başarısız oldu",
  "applicantIn": "Uygulama devam ediyor",
  "repaid": "geri ödeme",
  "overdue": "vadesi geçmiş",
  "estirepay": "tahmini geri ödeme",
  "loanDays": "Ödünç verilen gün sayısı",
  "reAmount": "geri ödeme tutarı",
  "repay": "geri ödeme modu",
  "entRepay": "Geri ödemeyi onayla",
  "foryourmoney": "Borç para sıkıntısı çekiyorsanız, borç alacak yer bulamıyorsanız veya arkadaşlarınızdan borç para almaktan utanıyorsanız, bizimle iletişime geçebilirsiniz. Şüphelerinizi istediğiniz zaman yanıtlamak için tüm profesyonel hizmet sürecine sahibiz. Amacımız, müşterilerin hızlı ve güvenli bir şekilde kullanabilmesi için her bir krediyi şeffaf hale getirmektir.",
  "onlineApplin": "Çevrimiçi başvurun",
  "businessloan": "Başlangıç kredisi başvurusu",
  "selectCountry": "Lütfen bir uyruk seçin",
  "selectPeriod": "Lütfen bir dönem seçin",
  "passPortImg": "Kimlik No./Pasaport No.",
  "uploadId": "Sertifika fotoğrafı/pasaport yüklemesi",
  "readAndAgree": "okudum ve kabul ediyorum",
  "loanAgree": "Kredi anlaşması",
  "submitApplica": "başvurunun sunulması",
  "photoExample": "Fotoğraf çekme örneği",
  "discounted": "indirimli ürünler",
  "days": "gün",
  "privacyPolicy": "Gizlilik Politikası",
  "delivery": "Teslimat ve teslim alma",
  "checkAgreement": "Lütfen sözleşmeyi işaretleyiniz!",
  "businessPhone": "İş telefonu",
  "businessEmail": "Kurumsal E-posta",

  "提交失败": "Gönderilemedi",
  "充值金额不能小于1": "Şarj miktarı 1'den az olamaz (iki ondalık basamak dahil)",
  "请切换其他语言后查看": "Lütfen görüntülemek için başka bir dile geçin",
  "我的购物车": "alışveriş sepetim",
  "推荐商品": "Önerilen ürünler",
  "猜你喜欢": "Sanırım hoşuna gitti.",
  "暂无店铺": "mağaza bulunamadı",
  "添加失败": "Gönderilemedi. Lütfen daha sonra tekrar deneyiniz",
  "提交订单": "sipariş gönderimi",
  recommendclass: "Tavsiye Kategorisi",
  "滑动验证": "Kaydırma doğrulaması",
  "最多上传9张图片":"En fazla 9 fotoğraf yükleme",
  "账号注销":"Hesap iptali",
  "确定注销":"İptal etmek istediğinizden emin misiniz?",
  "您的账号":"Hesabınız",
  "为什么要离开":"Neden ayrılmak istiyorsun?",
  "您还有余额,不能注销账号":"Hesabınızda bakiye var, hesabınızı iptal edemezsiniz!",
  "请输入注销理由":"Lütfen iptal nedeninizi girin",
  "您确认要注销吗?":"Hesabınızı iptal etmek istediğinizden emin misiniz?",
  "我再考虑下":"Daha sonra düşünüyorum",
  "同意注销": "İptal etmeyi kabul ediyorum",
  "注销成功":"İptal başarılı",
  "App下载(买家端)": "App indirme (alıcı tarafı)",
  "App下载(卖家端)": "App indirme (satıcı tarafı)",
  "最多包含10位小数": "En fazla 10 ondalık basamak içerebilir",
  "加密货币": "Şifreli para birimi",
  "企业电话": "Kurumsal telefon",
  "职业机会": "İş gereksinimleri",
  "银行卡": "banka kartı",
  "充值币种": "Şarj para birimi",
  "充值金额": "Şarj miktarı",
  '参数缺失': "Parametre eksik",
  '充值数量必填': "Şarj miktarı gereklidir",
  "充值金额不得小于": "Şarj miktarı 1'den az olamaz (iki ondalık basamak dahil)",
  "充值金额不得大于": "Şarj miktarı 100'den fazla olamaz (iki ondalık basamak dahil)",
  "长时间未付款，系统自动取消订单": "Uzun süre ödeme yapılmadı, sistem siparişi otomatik olarak iptal eder",
  "请先选择币种": "Lütfen önce para birimi seçin",
  "开户行": "Banka hesabı",
  "请输入开户行名称": "Lütfen banka hesabı adını girin",
  "银行卡号": "Banka kartı numarası",
  "点击去支付": "Ödemeye gitmek için tıklayın",
  "企业证明": "Şirket kanıtı",
  "请输入银行卡号": "Lütfen banka kartı numarasını girin",
  footTipTikTok:'CoveBuy Alışveriş Merkezi ©️2024 Telif Hakkı',
  TikTokFoot:"CoveBuy Mall, CoveBuy ve Asya'nın en büyük toptan ticaret şirketi Alibaba'nın ortaklaşa kurduğu küresel bir kısa video sosyal platformdur. Küresel bir e-ticaret platformudur ve dünyada Toronto, Kanada, Los Angeles ve Chiba, Japonya'da bulunan kendi kendine çalışan üç akıllı depoya sahiptir. Uygulamada satılan ürünler arasında Japonya, Güney Kore, Çin ve diğer Asya ülkelerinden popüler ürünler yer alıyor. Şu anda toplam sayı 50.000'i aştı ve hızla büyümeye devam ediyor.",
  "cancelInfo":"uyarmak! Lütfen hesabı iptal ederken dikkatli olun.Eğer hesabı artık kullanmıyorsanız [İptal Etmeyi Kabul Ediyorum] seçeneğine tıklayabilirsiniz.İptalin ardından birkaç gün içinde kayıt olamayabilirsiniz.",
  "betaBannerText": "Web sitesi kamuya açık test aşamasındadır, lütfen sipariş vermeyin"
}